import { Component, computed, input, output } from '@angular/core';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { MatCard } from '@angular/material/card';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { Card } from '../../../model/job.model';
import { HumanizePipe } from '../../../pipes/humanize.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'job-contacts',
  imports: [MatGridList, MatGridTile, MatCard, MatTabGroup, MatTab, MatTabLabel, HumanizePipe, MatIcon, MatIconButton],
  template: `
    <mat-grid-list class="my-0 mx-10" cols="3" gutterSize="10px" rowHeight="{{ extraLine() ? '141px' : '125px' }}">
      @for (card of cards(); track card.role) {
        @let contactInfo =
          [
            card.email && { icon: 'email', label: 'Email', value: card.email },
            card.postCode && { icon: 'pin_drop', label: 'Postcode', value: card.postCode },
            card.homePhone && { icon: 'home', label: 'Home phone', value: card.homePhone },
            card.mobilePhone && { icon: 'phone_iphone', label: 'Mobile phone', value: card.mobilePhone },
            card.workPhone && { icon: 'work', label: 'Work phone', value: card.workPhone }
          ].filter(Boolean);

        <mat-grid-tile>
          <mat-card class="text-charcoal-40 w-full min-w-[300px] body-2 self-start">
            <div class="w-full">
              <div class="body-2">
                {{ card.role | humanize }}
              </div>
              <div class="font-semibold! subtitle-1">
                {{ card.nameLine1 }}
              </div>
              @if (card.nameLine2) {
                <div>
                  {{ card.nameLine2 }}
                </div>
              }
            </div>

            @if (contactInfo.length > 0) {
              <mat-tab-group animationDuration="0ms" class="icon-tabs" disablePagination>
                @for (contact of contactInfo; track contact.label) {
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <mat-icon class="size-18! text-18!">{{ contact.icon }}</mat-icon>
                    </ng-template>
                    <div class="body-1 mt-5 min-h-20 break-all">
                      <span class="body-2 text-charcoal-60 pr-10">{{ contact.label }}</span> {{ contact.value }}
                    </div>
                  </mat-tab>
                }
              </mat-tab-group>
            }

            <div class="secondary-icon absolute top-3 right-5">
              @if (card.role === 'OWNER' && ownerEditable()) {
                <button matIconButton (click)="editOwner.emit()">
                  <mat-icon>create</mat-icon>
                </button>
              }
            </div>
          </mat-card>
        </mat-grid-tile>
      }
    </mat-grid-list>
  `
})
export class JobContactsComponent {
  cards = input.required<Card[]>();
  ownerEditable = input.required<boolean>();
  editOwner = output<void>();

  protected readonly Boolean = Boolean;

  extraLine = computed(() => this.cards().filter(({ nameLine2 }) => !!nameLine2).length > 0);
}
